import pro1 from "../assets/pro1.png";
import pro2 from "../assets/pro2.png";

const ProjectCardData = [
  {
    imgsrc: pro1,
    title: "Rent Cart Web App",
    text: "Proyecto orientado a la renta de autos. Tiene roles de admin y usuario. Usamos Angular y SpringBoot con Security",
    github: "https://github.com/FlayexClay/RentarCarrosBackend",
  },
  {
    imgsrc: pro2,
    title: "Pokedex Con PokeApi",
    text: "Pokedex donde encuentra todo los pokemones disponibles con la api PokeApi",
    github: "https://github.com/FlayexClay/PokedexReact",
  },
];

export default ProjectCardData;
